import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchgenericPageData } from "../apiservices/ApiService";
import AppNavigation from "../navigation/AppNavigation";

const Fsn76GenericUi = ({ onTap }) => {
  const { handleNavigation } = AppNavigation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchgenericPageData({ pageId: 1813 });
        setPageData(data);
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching page data:", error);
        setError(error.message);
        setLoading(false); // Also set loading to false in case of error
      }
    };

    fetchData();
  }, []);

  // Function to handle the back button
  const handleBackButtonPress = () => {
    if (window.Android) {
      // Call Android's Java function via the bridge
      window.Android.onBackPressed();
    } else {
      navigate(-1); // Navigate back
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: "#2c2c2c",
          color: "#ffffff",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          backgroundColor: "#2c2c2c",
          color: "#ffffff",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <div className="App">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <ArrowBackIosIcon
          sx={{ cursor: "pointer" }}
          onClick={handleBackButtonPress}
        />
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          {pageData.Title || "Generic UI"}
        </Typography>
      </Box>
      <Box padding={2}>
        <div style={{ backgroundColor: pageData.PageBgColour || "#FFF" }}>
          {pageData.Contains.map((item, index) => {
            switch (item.FeedType) {
              case "Text":
                return (
                  <p
                    key={index}
                    style={{
                      color: item.TextColor,
                      fontSize: `${item.TextSize * 2}px`,
                      fontWeight: item.TextStyle,
                    }}
                  >
                    {item.Text}
                  </p>
                );
              case "SpacerVertical":
                return (
                  <div
                    key={index}
                    style={{ marginTop: `${item.Value}px` }}
                  ></div>
                );
              default:
                return null;
            }
          })}
        </div>
      </Box>
    </div>
  );
};

export default Fsn76GenericUi;
